import React from 'react';
import AboutHero from '../components/about/AboutHero';
import AboutHistory from '../components/about/AboutHistory';
import AboutValues from '../components/about/AboutValues';
import AboutTeam from '../components/about/AboutTeam';
import AboutDifferentials from '../components/about/AboutDifferentials';
import AboutLocations from '../components/about/AboutLocations';
import AboutCertifications from '../components/about/AboutCertifications';
import AboutTestimonials from '../components/about/AboutTestimonials';
import AboutCTA from '../components/about/AboutCTA';

const About: React.FC = () => {
  return (
    <div className="overflow-hidden">
      <AboutHero />
      <AboutHistory />
      <AboutValues />
      <AboutDifferentials />
      <AboutLocations />
      <AboutCTA />
    </div>
  );
};

export default About;